import urlDecode from './urlcode.js';
import { message } from 'antd'
import createHistory from 'history/createHashHistory';
const history = createHistory();

let url = "ws://localhost:61126";  
let WS = new WebSocket(url);

// 连接身份证阅读器
function plguin_connect() {  
    var ws = undefined; 
    if ('WebSocket' in window) {  
        ws = new WebSocket(url);  
    } else if ('MozWebSocket' in window) {  
        ws = new MozWebSocket(url);  
    } else {  
        console.log("浏览器不支持 WebSocket");  
        return ;  
    }  
    ws.onopen = function() {  
        console.log("open");  
        console.log("已连接");  
        //设置发信息送类型为：ArrayBuffer  
        ws.binaryType = "arraybuffer";  
    }  
    ws.onmessage = function(e) {
        var	s = urlDecode(e.data.toString());
        console.log("[收到的数据]:"+s);
        var obj = JSON.parse(s);
        if( obj.result === "90" ) {
            console.log("[操作成功]:"+s);
        } else {
            console.log("失败"+s);
        }
        // errAlert(obj.result);
        
       
    }  
    ws.onclose = function(e) {  
        console.log("closed"); 
        ws =null;     
    }  
    ws.onerror = function(e) {  
        console.log("error");  
        ws =null; 
    }  
}  

//断开连接  
export const plguin_close=() =>{  
    console.log("ws");
    if (ws != null) {  
        ws.close();  
        ws = null;  
        message.success("断开")
    }  
} 

//向服务发送数据
function plguin_send(s){
    console.log("[send]--------------------------------------:"+s);  
    if (ws != null) {  
        ws.send(s);   
        
    }  
    else{
        console.log("[send]: ws null");  
    }
}


export const readCardAndFace = (callback,resetbtn) => {
    //使用websocket连接
    let thord = '';
    // let url = 'ws://localhost:61126';
    // WS = new WebSocket(url);
    var timer; //定时器
    WS.onopen = function() {
        console.log( "websocket连接建立，可以进行通信" );
        WS.binaryType = "arraybuffer"
    };

    WS.onmessage = function(e) {
        var	s = urlDecode(e.data.toString());
        var obj = JSON.parse(s);
        switch (obj.repcode) {
            case "open":
                if ( obj.result === "90" ) {
                    console.log( " 连接设备成功！ " );
                    message.success( " 连接设备成功！ " )
                } 
                // else if ( obj.result === "01" || obj.result === "03") {
                //     message.warn(" 请检查人脸识别设备正常连接后再试！ ");
                // } 
                else if ( obj.result === "00") {
                    console.log(" 无事件！ ");
                } else {
                    message.warn(" 连接设备失败，请检查人脸识别设备正常连接后再试！ ");
                    WS.onclose()
                    window.clearInterval(timer);
                    resetbtn()
                }
                break;
            case "listen":
                    if ( obj.result === "90"  && obj.status == '1' ) {
                        callback(obj);
                        if(thord == 'manual'){
                            console.log("2222",thord);
                            WS.onclose();
                            window.clearInterval(timer);
                            resetbtn();
                        }
                    } else if( obj.result === "90"  && obj.status == '0') {
                        message.warn(" 人证比对失败！ ");
                        console.log(" 人证比对失败！ ");
                    } else if( obj.result === "90"  || obj.result == '00') {
                        
                    } else {
                        message.warn(" 监听失败，请检查人脸识别设备正常连接后再试！ ");
                        WS.onclose();
                        window.clearInterval(timer)
                        resetbtn()
                    }
                break;
            case "close":
                if ( obj.result === "90") {
                    message.success(" 已关闭设备连接！ ")  
                }
                break;
            default:
                break;
        }

        // if( obj.result === "90"  && obj.status == '1') {
        //     // console.log("[身份证认证及人脸认证成功]:"+s);
        //     callback(obj)
        // } else if ( obj.result === "01" || obj.result === "03") {
        //     message.warn(" 请检查人脸识别设备正常连接后再试！ ");
        // }
        // else if( obj.result === "90"  && obj.status == '0') {
        //     message.warn(" 人证比对失败！ ");
        // } else if ( obj.result === "00"){
        //     // console.log("[设备正常，未有操作]:");
        // } else if ( obj.result === "90" ) {
        //     // console.log("[设备正常，操作正常]:");
        // } 
        // else {
        //     console.log("连接异常"+s);
        // }
 
    }  
    WS.onclose = function(e) {  
        console.log("closed"); 
        WS =null;     
        window.clearInterval(timer)     
        resetbtn()  
        // message.success(" 已关闭设备连接！ ")  
    }  
    WS.onerror = function(e) {  
        console.log("error");  
        WS =null; 
    }  

    return  {
        //开启连接
        open: ()=>{
            console.log('正在打开连接');
            var obj = { reqcode:'open' };
            var str =JSON.stringify(obj);
            // if( ws.readyState === '1' ) {
            //     ws.send(str);
            // }
            // 设置延迟 websocket连接后再发送
            var waitopen =  setInterval(() => {
                if( WS.readyState == 1 ) {
                    WS.send(str);
                    clearInterval(waitopen);
                }
            }, 50);
            //window.clearInterval(timer);//清除原有的轮询
        },
        listen:(e)=>{
            if(e == 'manual'){
                timer = window.setInterval(function(){
                    var obj = { reqcode:'listen' };
                    thord = 'manual'
                    var str =JSON.stringify(obj);
                    WS.send(str);
                },500)
            }else{
                timer = window.setInterval(function(){
                    var obj = { reqcode:'listen' };
                    var str =JSON.stringify(obj);
                    WS.send(str);
                },500)
            }
        },
        stop:()=>{
            console.log("关闭设备成功");
            var obj = { reqcode:'close' };
            var str =JSON.stringify(obj);
            WS.send(str);
            window.clearInterval(timer);
        }
    }
}

const unlisten = history.listen((location, action) => {
    // location is an object like window.location
    if(location.pathname.indexOf('/yxxc') == -1){
        // console.log("关闭设备成功");
        var obj = { reqcode:'close' };
        var str =JSON.stringify(obj);
        WS.send(str);
    }
    // console.log("路由监听----------",action, location.pathname, location.state)
}) 


// WEBPACK FOOTER //
// ./utils/readCardAndFace.js